import { toFixed } from '../../../../core/services/utils/numbers';

/**
 * Value Object para calcular o valor de Customer Share através de um valor base e o percentual de Customer Share
 */
export class CustomerShareValorValueObject {
    private _valorBase: number;
    private _customerShare: number;
    private _valor: number;

    constructor(valorBase: number, customerShare: number) {
        this._valorBase = valorBase;
        this._customerShare = customerShare;
        this.calcularValorCustomerShare();
    }

    /**
     * Retorna o valor calculado do Customer Share
     */
    get valor(): number {
        return this._valor;
    }

    /**
     * Calcula o valor do Customer Share baseado no valor base e percentual
     */
    private calcularValorCustomerShare(): void {
        if (this._valorBase === 0 || this._customerShare === 0) {
            this._valor = 0;
            return;
        }

        const valor = (this._valorBase * this._customerShare) / 100;
        this._valor = toFixed(valor, 2);
    }
}
